import * as React from 'react';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import { EmphasizedTextRed, Text } from '../style.css';
import { LogoImg } from '../../Logo';
import { api } from '../../../helpers/routes';
import Button from '../../UI/Button';
import Input from '../../UI/Input/Input';
import { isValidEmail } from '../../../helpers/validation';
import VerticalSpacer from '../../UI/VerticalSpacer';

/* Helpers */
const validationFailedMsg = 'Please enter a valid email address.';

/* Components */
class SubscriptionForm extends React.Component<{ onSubmitSuccess: () => void }, { validationFailed: boolean }> {
  private readonly emailFieldRef = React.createRef<HTMLInputElement>();

  constructor(props) {
    super(props);
    this.state = { validationFailed: false };
  }

  componentDidMount(): void {
    this.emailFieldRef.current.addEventListener('invalid', () => {
      this.setState({ validationFailed: true });
    });
  }

  handleChange = () => {
    this.setState({ validationFailed: false });
  };

  handleSubmit = e => {
    const { onSubmitSuccess } = this.props;

    if (e) {
      e.preventDefault();
    }

    const emailField = this.emailFieldRef.current;

    if (!emailField || !isValidEmail(emailField.value)) {
      this.setState({ validationFailed: true });
      return;
    }

    emailField &&
      axios
        .post(api.newsletterSignup, { email: emailField.value })
        .then(onSubmitSuccess)
        .catch(error => Sentry.captureException(error));
  };

  render() {
    const { validationFailed } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <div style={{ width: '340px', margin: 'auto', maxWidth: '95%' }}>
          <Input
            height="46px"
            width="100%"
            name="email"
            placeholder="Email"
            ref={this.emailFieldRef}
            hasError={validationFailed}
            errorText={validationFailed ? validationFailedMsg : null}
            handleChange={this.handleChange}
            justifyContent="center"
            required
            autofocus
          />
        </div>
        <Button type="submit" width="340px" maxWidth="95%">
          SUBSCRIBE NOW
        </Button>
      </form>
    );
  }
}

const SignUpView: React.ComponentType<{ onSubmitSuccess: () => void; s3BasePath: string }> = ({
  onSubmitSuccess,
  s3BasePath
}: {
  onSubmitSuccess: () => void;
  s3BasePath: string;
}) => (
  <React.Fragment>
    <VerticalSpacer mobileHeight="10px" />
    <LogoImg s3BasePath={s3BasePath} margin="24px 0 0 0" width="90px" height="35px" />
    <Text>
      Subscribe now to <EmphasizedTextRed>save up to 30%</EmphasizedTextRed> on your favorite luxury items!
    </Text>
    <SubscriptionForm onSubmitSuccess={onSubmitSuccess} />
  </React.Fragment>
);

export default SignUpView;
